/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { StoreType } from '../stores/storesClientTypings';
import { factoryT, fields, factoryTBuilder } from 'factory-t';
import {
    ActivityDto,
    CashRegisterModelShortDto,
    CityResource,
    FirmwareVersionDTO,
    FiscalDriverVersionDto,
    OperatorShortDto,
    RegionResource,
    StoreLowerActivity,
    StoreMainActivity,
    StoreMiddleActivity,
    StoreTypeResource,
    TaxationTypeDTO,
    TaxAuthorityDTO,
    UserShortDto,
} from './shortListsClient.typings';
import { TAXATION_TYPES } from '../companies/companiesClient.typings';

export const storeTypeFactory = factoryT<StoreTypeResource>({
    id: fields.index(),
    name: fields.sequence(Object.values(StoreType)),
});

export const cashRegisterModelShortDtoFactory = factoryT<CashRegisterModelShortDto>({
    taxNumber: (ctx) => `000${ctx.index}`,
    name: (ctx) => `Model 2019_#${ctx.index}`,
    operatorTaxNumber: (ctx) => `02000007${ctx.index}`,
});

export const operatorShortDtoFactory = factoryT<OperatorShortDto>({
    companyName: (ctx) => `Operator #${ctx.index}`,
    companyTaxNumber: (ctx) => `02000007${ctx.index}`,
});

export const userShortDtoFactory = factoryT<UserShortDto>({
    id: (ctx) => ctx.index,
    firstName: fields.sequence(['Ivan', 'Peter', 'Philip', 'Eugen', 'Andrey', 'Sergey']),
    lastName: (ctx) => 'Ivanov' + ctx.index.toString(),
});

export const firmwareVersionFactory = factoryT<FirmwareVersionDTO>({
    id: (ctx) => ctx.index + 22,
    //name: (ctx) => `v.${ctx.index}0.00.00`,
    name: fields.sequence(['2.6.1-werw', '2.32.0', '2.20.0', '2.20', '2.20-dfgdfgdf', '3.45', '3', '1.5', '2', '']),
});

export const fiscalDriverVersionFactory = factoryT<FiscalDriverVersionDto>({
    id: (ctx) => ctx.index + 22,
    name: (ctx) => `v.${ctx.index}0.00.00`,
});

export const taxAuthorityFactory = factoryT<TaxAuthorityDTO>({
    id: (ctx) => `${ctx.index + 22}`,
    name: (ctx) => `TaxAuthority-${ctx.index}`,
});

export const taxationTypeFactory = factoryT<TaxationTypeDTO>({
    id: (ctx) => ctx.index,
    name: fields.sequence(Object.values(TAXATION_TYPES)),
});

export const cityDtoFactory = factoryTBuilder<CityResource>({
    id: (ctx) => ctx.index,
    name: (ctx) => `City-${ctx.index}`,
}).factory();

export const regionDtoFactory = factoryTBuilder<RegionResource>({
    id: (ctx) => ctx.index,
    name: (ctx) => `Region ${ctx.index}`,
    code: (ctx) => `0127${ctx.index}`,
}).factory();

export const mainActivitiesDtoFactory = factoryTBuilder<ActivityDto>({
    id: (ctx) => ctx.index,
    name: fields.sequence([
        ...Object.values(StoreMainActivity),
        'YENİ FƏALİYYƏT-2',
        'YENİ FƏALİYYƏT-1',
        'Azərbaycan-2',
        'Azərbaycan-1',
    ]),
}).factory();

export const middleActivitiesDtoFactory = factoryTBuilder<ActivityDto>({
    id: (ctx) => ctx.index,
    name: fields.sequence([
        ...Object.values(StoreMiddleActivity),
        'YENİ FƏALİYYƏT-4',
        'YENİ FƏALİYYƏT-3',
        'Azərbaycan-4',
        'Azərbaycan-3',
    ]),
}).factory();

export const lowerActivitiesDtoFactory = factoryTBuilder<ActivityDto>({
    id: (ctx) => ctx.index,
    name: fields.sequence([
        ...Object.values(StoreLowerActivity),
        'YENİ FƏALİYYƏT-6',
        'YENİ FƏALİYYƏT-5',
        'Azərbaycan-6',
        'Azərbaycan-5',
    ]),
}).factory();
